<template>
    <console-content max-width="1920px">

        <v-row align="center" class="mt-3">
            <v-col cols="auto" class="headline">통계 (발행일기준)</v-col>
        </v-row>

        <v-row class="mt-4" no-gutters align="end">
            <v-col cols="auto">
                <v-month-field v-model="filter.month" class="mx-auto" label="발행일자" placeholder=" " hide-details @input="search"></v-month-field>
            </v-col>
            <v-spacer />
            <v-col v-if="!hasViewerScope" cols="auto">
                <v-btn color="white" @click="excel" class="green--text">
                    <v-icon left size="20">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="statisticsHeaders" :items="statistics" :loading="loading" disable-sort disable-pagination hide-default-footer class="elevation-1 mt-4">
            <template slot="item.cp.name" slot-scope="{item}">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="cp, i in item.cps">
                        <tr :key="i">
                            <th class="text-end"><v-divider v-if="!!i"/><span class="cell">{{ cp.name }}</span></th>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.type" slot-scope="{item}">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="{ type }, i in item.types">
                        <tr :key="i">
                            <th class="text-center"><v-divider v-if="!!i"/><span class="cell">{{ type }}</span></th>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.issue.count" slot-scope="{item}">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="issue, i in item.issues">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i"/><span class="cell">{{ issue.count.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.issue.price" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="issue, i in item.issues">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i"/><span class="cell">{{ issue.price.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
            
            <template slot="item.nonpayment.count" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="nonpayment, i in item.nonpayments">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i"/><span class="cell">{{ nonpayment.count.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.nonpayment.price" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="nonpayment, i in item.nonpayments">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i"/><span class="cell">{{ nonpayment.price.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>

            <template slot="item.payment.count" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="payment, i in item.payments">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i"/><span class="cell">{{ payment.count.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.payment.price" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="payment, i in item.payments">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i"/><span class="cell">{{ payment.price.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>

            <template slot="item.cancel.count" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="cancel, i in item.cancels">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i"/><span class="cell">{{ cancel.count.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.cancel.price" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="cancel, i in item.cancels">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i"/><span class="cell">{{ cancel.price.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
        </v-data-table>

        <div class="headline text-start mt-8">합계</div>
        <v-data-table :headers="totalStatisticsHeaders" :items="total" :loading="loading" disable-sort
            disable-pagination hide-default-footer class="elevation-1 mt-4">
            <template slot="item.cp.name" slot-scope="{item}">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="cp, i in item.cps">
                        <tr :key="i">
                            <th class="text-end"><v-divider v-if="!!i" :class="item.cps.length - 2 === i ? 'divider-border' : ''"/><span class="cell">{{ cp.name }}</span></th>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.type" slot-scope="{item}">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="{ type }, i in item.types">
                        <tr :key="i">
                            <th class="text-center"><v-divider v-if="!!i" :class="item.types.length - 2 === i ? 'divider-border' : ''"/><span class="cell">{{ type }}</span></th>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.issue.count" slot-scope="{item}">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="issue, i in item.issues">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i" :class="item.issues.length - 2 === i ? 'divider-border' : ''"/><span class="cell">{{ issue.count.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.issue.price" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="issue, i in item.issues">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i" :class="item.issues.length - 2 === i ? 'divider-border' : ''"/><span class="cell">{{ issue.price.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
            
            <template slot="item.nonpayment.count" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="nonpayment, i in item.nonpayments">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i" :class="item.nonpayments.length - 2 === i ? 'divider-border' : ''"/><span class="cell">{{ nonpayment.count.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.nonpayment.price" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="nonpayment, i in item.nonpayments">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i" :class="item.nonpayments.length - 2 === i ? 'divider-border' : ''"/><span class="cell">{{ nonpayment.price.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>

            <template slot="item.payment.count" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="payment, i in item.payments">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i" :class="item.payments.length - 2 === i ? 'divider-border' : ''"/><span class="cell">{{ payment.count.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.payment.price" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="payment, i in item.payments">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i" :class="item.payments.length - 2 === i ? 'divider-border' : ''"/><span class="cell">{{ payment.price.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>

            <template slot="item.cancel.count" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="cancel, i in item.cancels">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i" :class="item.cancels.length - 2 === i ? 'divider-border' : ''"/><span class="cell">{{ cancel.count.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
            <template slot="item.cancel.price" slot-scope="{ item }">
                <table width="100%" border="0" cellspacing="0">
                    <template v-for="cancel, i in item.cancels">
                        <tr :key="i">
                            <td class="text-end"><v-divider v-if="!!i" :class="item.cancels.length - 2 === i ? 'divider-border' : ''"/><span class="cell">{{ cancel.price.format() }}</span></td>
                        </tr>
                    </template>
                </table>
            </template>
        </v-data-table>
    </console-content>
</template>

<script>
import api from "@/api";
import { mapGetters } from "vuex";
import ConsoleContent from "@/components/console/console-content.vue";
import VMonthField from "@/components/plugins/vuetify/v-month-field.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";

import XLSX from 'xlsx';
import dayjs from "dayjs";
import { mdiMicrosoftExcel } from '@mdi/js';

export default {
    components: {
        ConsoleContent,
        VMonthField,
        VDateField
    },
    data() {
        return {
            mdiMicrosoftExcel,

            loading: true,

            filter: {
                month: dayjs().format("YYYY-MM"),
            },

            statistics: [],
            statisticsHeaders: [
                { text: "날짜", align: "center", value: "ymd", width: 120, }, 
                { text: "CP", align: "center", value: "cp.name", width: 300, },
                { text: "TYPE", align: "center", value: "type", width: 100, },
                { text: "총 발행(건)", align: "center", value: "issue.count", width: 100, }, 
                { text: "총 발행(금액)", align: "center", value: "issue.price", width: 140, },
                { text: "미사용(건)", align: "center", value: "nonpayment.count", width: 90, }, 
                { text: "미사용(금액)", align: "center", value: "nonpayment.price", width: 140, },
                { text: "사용(건)", align: "center", value: "payment.count", width: 110, }, 
                { text: "사용(금액)", align: "center", value: "payment.price", width: 140, },
                { text: "폐기(건)", align: "center", value: "cancel.count", width: 110, }, 
                { text: "폐기(금액)", align: "center", value: "cancel.price", width: 130, },
            ],

            totalStatisticsHeaders: [
                { text: "날짜", align: "center", value: "ymd", width: 120, }, 
                { text: "CP", align: "center", value: "cp.name", width: 300, },
                { text: "TYPE", align: "center", value: "type", width: 100, },
                { text: "총 발행(건)", align: "center", value: "issue.count", width: 100, }, 
                { text: "총 발행(금액)", align: "center", value: "issue.price", width: 140, },
                { text: "미사용(건)", align: "center", value: "nonpayment.count", width: 90, }, 
                { text: "미사용(금액)", align: "center", value: "nonpayment.price", width: 140, },
                { text: "사용(건)", align: "center", value: "payment.count", width: 110, }, 
                { text: "사용(금액)", align: "center", value: "payment.price", width: 140, },
                { text: "폐기(건)", align: "center", value: "cancel.count", width: 120, }, 
                { text: "폐기(금액)", align: "center", value: "cancel.price", width: 130, },
            ],

            cps: [],
            categories: [],
        };
    },

    mounted(){
        this.init();
        if(this.hasViewerScope) this.addEvents();
    },

    beforeDestroy(){
        if(this.hasViewerScope) this.removeEvents();
    },

    methods: {
        async init(){
            var { me } = await api.console.me.get();
            this.categories = me.categories;

            var { cps } = await api.console.me.cps.gets({ headers: { limit: 0 } });
            this.cps = cps;

            await this.search();
        },

        validate(){
            try{
                if(!this.filter.month) alert("발행일자를 선택해주세요");

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        async search(){
            if(this.validate()){
                this.loading = true;

                var { statistics } = await api.console.pins.statistics("issued-at", {
                    params: this.filter
                });

                let _statistics = [];
                for(let { ymd, dayStatistics } of statistics){
                    let cps = [];
                    let types = [];
                    let issues = [];
                    let payments = [];
                    let nonpayments = [];
                    let cancels = [];
                    
                    for(let cp of this.cps){
                        let cpStatistics = dayStatistics.filter(statistic => statistic._cp == cp._id);
                        if(!cpStatistics.length) continue;
                        
                        if(cpStatistics.find(({ type }) => type == "api")){
                            cps.push({ _id: cp._id, name: cp.name, type: "api" });
                            types.push({ _id: cp._id, name: cp.name, type: "API" });
                            
                            issues.push({
                                _id: cp._id,
                                name: cp.name,
                                type: "api",
                                count: cpStatistics.filter(({ type }) => type == "api").reduce((count, statistic) => count + statistic.count, 0),
                                price: cpStatistics.filter(({ type }) => type == "api").reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: cpStatistics.reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                            nonpayments.push({
                                _id: cp._id,
                                name: cp.name, 
                                type: "api",
                                count: cpStatistics.filter(({ status, type }) => status == 1 && type == "api").reduce((count, statistic) => count + statistic.count, 0),
                                price: cpStatistics.filter(({ status, type }) => status == 1 && type == "api").reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: cpStatistics.filter(({ status }) => status == 1).reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                            payments.push({
                                _id: cp._id,
                                name: cp.name, 
                                type: "api",
                                count: cpStatistics.filter(({ status, type }) => status == 7 && type == "api").reduce((count, statistic) => count + statistic.count, 0),
                                price: cpStatistics.filter(({ status, type }) => status == 7 && type == "api").reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: cpStatistics.filter(({ status }) => status == 7).reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                            cancels.push({
                                _id: cp._id,
                                name: cp.name, 
                                type: "api",
                                count: cpStatistics.filter(({ status, type }) => status == 8 && type == "api").reduce((count, statistic) => count + statistic.count, 0),
                                price: cpStatistics.filter(({ status, type }) => status == 8 && type == "api").reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: cpStatistics.filter(({ status }) => status == 8).reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                        }

                        if(cpStatistics.find(({ type }) => type != "api")){
                            cps.push({ _id: cp._id, name: cp.name, type: "manual" });
                            types.push({ _id: cp._id, name: cp.name, type: "수동(벌크)" });
                            
                            issues.push({
                                _id: cp._id,
                                name: cp.name,
                                type: "manual",
                                count: cpStatistics.filter(({ type }) => type != "api").reduce((count, statistic) => count + statistic.count, 0),
                                price: cpStatistics.filter(({ type }) => type != "api").reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: cpStatistics.reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                            nonpayments.push({
                                _id: cp._id,
                                name: cp.name, 
                                type: "manual",
                                count: cpStatistics.filter(({ status, type }) => status == 1 && type != "api").reduce((count, statistic) => count + statistic.count, 0),
                                price: cpStatistics.filter(({ status, type }) => status == 1 && type != "api").reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: cpStatistics.filter(({ status }) => status == 1).reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                            payments.push({
                                _id: cp._id,
                                name: cp.name, 
                                type: "manual",
                                count: cpStatistics.filter(({ status, type }) => status == 7 && type != "api").reduce((count, statistic) => count + statistic.count, 0),
                                price: cpStatistics.filter(({ status, type }) => status == 7 && type != "api").reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: cpStatistics.filter(({ status }) => status == 7).reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                            cancels.push({
                                _id: cp._id,
                                name: cp.name, 
                                type: "manual",
                                count: cpStatistics.filter(({ status, type }) => status == 8 && type != "api").reduce((count, statistic) => count + statistic.count, 0),
                                price: cpStatistics.filter(({ status, type }) => status == 8 && type != "api").reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: cpStatistics.filter(({ status }) => status == 8).reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                        }
                    }

                    let manualStatistics = dayStatistics.filter(statistic => !statistic._cp);
                    if(manualStatistics.length){
                        
                        if(manualStatistics.find(({ type }) => type != "api")){
                            cps.push({ _id: null, name: "수동(벌크)", type: "manual" });
                            types.push({ _id: null, name: "수동(벌크)", type: "수동(벌크)" });
    
                            issues.push({
                                _id: null,
                                name: "수동(벌크)",
                                type: "manual",
                                count: manualStatistics.reduce((count, statistic) => count + statistic.count, 0),
                                price: manualStatistics.reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: manualStatistics.reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                            nonpayments.push({
                                _id: null,
                                name: "수동(벌크)",
                                type: "manual",
                                count: manualStatistics.filter(({ status }) => status == 1).reduce((count, statistic) => count + statistic.count, 0),
                                price: manualStatistics.filter(({ status }) => status == 1).reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: manualStatistics.filter(({ status }) => status == 1).reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                            payments.push({
                                _id: null,
                                name: "수동(벌크)",
                                type: "manual",
                                count: manualStatistics.filter(({ status }) => status == 7).reduce((count, statistic) => count + statistic.count, 0),
                                price: manualStatistics.filter(({ status }) => status == 7).reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: manualStatistics.filter(({ status }) => status == 7).reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                            cancels.push({
                                _id: null,
                                name: "수동(벌크)",
                                type: "manual",
                                count: manualStatistics.filter(({ status }) => status == 8).reduce((count, statistic) => count + statistic.count, 0),
                                price: manualStatistics.filter(({ status }) => status == 8).reduce((price, statistic) => price + statistic.price, 0),
                                // pnos: manualStatistics.filter(({ status }) => status == 8).reduce((pnos, statistic) => [...pnos, ...statistic.pnos], [])
                            });
                        }
                    }

                    _statistics.push({
                        ymd,
                        cps,
                        types,
                        issues,
                        nonpayments,
                        payments,
                        cancels
                    })
                }

                this.statistics = _statistics;
                this.loading = false;
            }
        },

        excel(){
            var data = [];
            for(var { ymd, cps, types, issues, nonpayments, payments, cancels } of this.statistics){
                for(let index in cps){
                    data.push({
                        "날짜": ymd,
                        "발행처": cps[index].name,
                        "TYPE": types[index].type,
                        "발행(건)": issues[index]?.count ?? 0,
                        "발행(금액)": issues[index]?.price ?? 0,
                        "미사용(건)": nonpayments[index]?.count ?? 0,
                        "미사용(금액)": nonpayments[index]?.price ?? 0,
                        "사용(건)": payments[index]?.count ?? 0,
                        "사용(금액)": payments[index]?.price ?? 0,
                        "폐기(건)": cancels[index]?.count ?? 0,
                        "폐기(금액)": cancels[index]?.price ?? 0,
                    });
                }
            }

            for(var { ymd, cps, types, issues, nonpayments, payments, cancels } of this.total){
                for(let index in cps){
                    data.push({
                        "날짜": ymd,
                        "발행처": cps[index].name,
                        "TYPE": types[index].type,
                        "발행(건)": issues[index]?.count ?? 0,
                        "발행(금액)": issues[index]?.price ?? 0,
                        "미사용(건)": nonpayments[index]?.count ?? 0,
                        "미사용(금액)": nonpayments[index]?.price ?? 0,
                        "사용(건)": payments[index]?.count ?? 0,
                        "사용(금액)": payments[index]?.price ?? 0,
                        "폐기(건)": cancels[index]?.count ?? 0,
                        "폐기(금액)": cancels[index]?.price ?? 0,
                    });
                }
            }

            var workBook = new XLSX.utils.book_new();
            var workSheet = XLSX.utils.json_to_sheet(data);

            XLSX.utils.book_append_sheet(workBook, workSheet, "new");
            XLSX.writeFile(workBook, "통계 목록 " + this.filter.month + ".xlsx");
        },

        preventDefault(e) {
            e.preventDefault()
        },
        addEvents() {
            //마우스 오른쪽 방지
            document.addEventListener('contextmenu', this.preventDefault);
            //텍스트 선택 방지
            document.addEventListener('selectstart', this.preventDefault);
            //복사 금지
            document.addEventListener('copy', this.preventDefault);
        },
        removeEvents() {
            //마우스 오른쪽 방지
            document.removeEventListener('contextmenu', this.preventDefault);
            //텍스트 선택 방지
            document.removeEventListener('selectstart', this.preventDefault);
            //복사 금지
            document.removeEventListener('copy', this.preventDefault);
        }

    },
    computed: {
        ...mapGetters(["hasViewerScope"]),
        total(){
            let total = {
                ymd: this.filter.month,
                cps: [],
                types: [],
                issues: [],
                nonpayments: [],
                payments: [],
                cancels: [],
            };

            for(let cp of this.cps){

                if(this.statistics.find(({ ymd, cps }) => cps.find(({ _id, type }) => _id == cp._id && type == "api" ))){
                    total.cps.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "api"
                    });

                    total.types.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "api"
                    });
    
                    total.issues.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "api",
                        count: this.statistics.reduce((count, { issues }) => count + (issues.find(({ _id, type }) => _id == cp._id && type == "api")?.count || 0), 0),
                        price: this.statistics.reduce((price, { issues }) => price + (issues.find(({ _id, type }) => _id == cp._id && type == "api")?.price || 0), 0),
                    });
    
                    total.nonpayments.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "api",
                        count: this.statistics.reduce((count, { nonpayments }) => count + (nonpayments.find(({ _id, type }) => _id == cp._id && type == "api")?.count || 0), 0),
                        price: this.statistics.reduce((price, { nonpayments }) => price + (nonpayments.find(({ _id, type }) => _id == cp._id && type == "api")?.price || 0), 0),
                    });
                    
                    total.payments.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "api",
                        count: this.statistics.reduce((count, { payments }) => count + (payments.find(({ _id, type }) => _id == cp._id && type == "api")?.count || 0), 0),
                        price: this.statistics.reduce((price, { payments }) => price + (payments.find(({ _id, type }) => _id == cp._id && type == "api")?.price || 0), 0),
                    });
    
                    total.cancels.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "api",
                        count: this.statistics.reduce((count, { cancels }) => count + (cancels.find(({ _id, type }) => _id == cp._id && type == "api")?.count || 0), 0),
                        price: this.statistics.reduce((price, { cancels }) => price + (cancels.find(({ _id, type }) => _id == cp._id && type == "api")?.price || 0), 0),
                    });
                }
                
                if(this.statistics.find(({ ymd, cps }) => cps.find(({ _id, type }) => _id == cp._id && type != "api" ))){
                    total.cps.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "manual",
                    });

                    total.types.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "수동(벌크)"
                    });
    
                    total.issues.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "manual",
                        count: this.statistics.reduce((count, { issues }) => count + (issues.find(({ _id, type }) => _id == cp._id && type != "api")?.count || 0), 0),
                        price: this.statistics.reduce((price, { issues }) => price + (issues.find(({ _id, type }) => _id == cp._id && type != "api")?.price || 0), 0),
                    });
    
                    total.nonpayments.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "manual",
                        count: this.statistics.reduce((count, { nonpayments }) => count + (nonpayments.find(({ _id, type }) => _id == cp._id && type != "api")?.count || 0), 0),
                        price: this.statistics.reduce((price, { nonpayments }) => price + (nonpayments.find(({ _id, type }) => _id == cp._id && type != "api")?.price || 0), 0),
                    });
                    
                    total.payments.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "manual",
                        count: this.statistics.reduce((count, { payments }) => count + (payments.find(({ _id, type }) => _id == cp._id && type != "api")?.count || 0), 0),
                        price: this.statistics.reduce((price, { payments }) => price + (payments.find(({ _id, type }) => _id == cp._id && type != "api")?.price || 0), 0),
                    });
    
                    total.cancels.push({
                        _id: cp._id,
                        name: cp.name,
                        type: "manual",
                        count: this.statistics.reduce((count, { cancels }) => count + (cancels.find(({ _id, type }) => _id == cp._id && type != "api")?.count || 0), 0),
                        price: this.statistics.reduce((price, { cancels }) => price + (cancels.find(({ _id, type }) => _id == cp._id && type != "api")?.price || 0), 0),
                    });
                }
            }

            if(this.statistics.find(({ ymd, cps }) => cps.find(({ _id }) => _id == null))){
                total.cps.push({
                    _id: null,
                    name: "수동(벌크)",
                    type: "manual",
                });

                total.types.push({
                    _id: null,
                    name: "수동(벌크)",
                    type: "수동(벌크)"
                });

                total.issues.push({
                    _id: null,
                    name: "수동(벌크)",
                    type: "manual",
                    count: this.statistics.reduce((count, { issues }) => count + (issues.find(({ _id }) => _id == null)?.count || 0), 0),
                    price: this.statistics.reduce((price, { issues }) => price + (issues.find(({ _id }) => _id == null)?.price || 0), 0),
                });

                total.nonpayments.push({
                    _id: null,
                    name: "수동(벌크)",
                    type: "manual",
                    count: this.statistics.reduce((count, { nonpayments }) => count + (nonpayments.find(({ _id }) => _id == null)?.count || 0), 0),
                    price: this.statistics.reduce((price, { nonpayments }) => price + (nonpayments.find(({ _id }) => _id == null)?.price || 0), 0),
                });
                
                total.payments.push({
                    _id: null,
                    name: "수동(벌크)",
                    type: "manual",
                    count: this.statistics.reduce((count, { payments }) => count + (payments.find(({ _id }) => _id == null)?.count || 0), 0),
                    price: this.statistics.reduce((price, { payments }) => price + (payments.find(({ _id }) => _id == null)?.price || 0), 0),
                });

                total.cancels.push({
                    _id: null,
                    name: "수동(벌크)",
                    type: "manual",
                    count: this.statistics.reduce((count, { cancels }) => count + (cancels.find(({ _id }) => _id == null)?.count || 0), 0),
                    price: this.statistics.reduce((price, { cancels }) => price + (cancels.find(({ _id }) => _id == null)?.price || 0), 0),
                });
            }

            total.cps.push({ name: "API 총 합계", type: '합계' }, { name: "수동(벌크) 총 합계", type: '합계' });

            total.cancels.push(
                { name: "API 총 합계", count: total.cancels.reduce((acc, cur) => acc += cur?.type === "api" ? cur.count : 0, 0), price: total.cancels.reduce((acc, cur) => acc += cur?.type === "api" ? cur.price : 0, 0)},
                { name: "수동(벌크) 총 합계", count: total.cancels.reduce((acc, cur) => acc += cur?.type === "manual" ? cur.count : 0, 0), price: total.cancels.reduce((acc, cur) => acc += cur?.type === "manual" ? cur.price : 0, 0)}
            )
            total.issues.push(
                { name: "API 총 합계", count: total.issues.reduce((acc, cur) => acc += cur?.type === "api" ? cur.count : 0, 0), price: total.issues.reduce((acc, cur) => acc += cur?.type === "api" ? cur.price : 0, 0)},
                { name: "수동(벌크) 총 합계", count: total.issues.reduce((acc, cur) => acc += cur?.type === "manual" ? cur.count : 0, 0), price: total.issues.reduce((acc, cur) => acc += cur?.type === "manual" ? cur.price : 0, 0)}
            )
            total.nonpayments.push(
                { name: "API 총 합계", count: total.nonpayments.reduce((acc, cur) => acc += cur?.type === "api" ? cur.count : 0, 0), price: total.nonpayments.reduce((acc, cur) => acc += cur?.type === "api" ? cur.price : 0, 0)},
                { name: "수동(벌크) 총 합계", count: total.nonpayments.reduce((acc, cur) => acc += cur?.type === "manual" ? cur.count : 0, 0), price: total.nonpayments.reduce((acc, cur) => acc += cur?.type === "manual" ? cur.price : 0, 0)}
            )
            total.payments.push(
                { name: "API 총 합계", count: total.payments.reduce((acc, cur) => acc += cur?.type === "api" ? cur.count : 0, 0), price: total.payments.reduce((acc, cur) => acc += cur?.type === "api" ? cur.price : 0, 0)},
                { name: "수동(벌크) 총 합계", count: total.payments.reduce((acc, cur) => acc += cur?.type === "manual" ? cur.count : 0, 0), price: total.payments.reduce((acc, cur) => acc += cur?.type === "manual" ? cur.price : 0, 0)}
            )
            total.types.push({ name: "API 총 합계", type: '합계' }, { name: "수동(벌크) 총 합계", type: '합계' })

            return [total];
        }
    }
}
</script>

<style scoped>
.v-data-table >>> th, .v-data-table >>> td {
    padding: 0px !important;
}
.v-data-table >>> .cell {
    padding: 0px 8px !important;
}
.divider-border {
    border-width: 1px;
    border-color: black;
}
</style>